const savedDiscounts = localStorage.getItem('savedDiscounts')
if (!savedDiscounts && onePlanetMembership.isSubscribed) {
  fetch('/checkout?discount=' + onePlanetMembership.discountCodes).catch(err => {
    console.error('Error adding discounts', err)
  });
  localStorage.setItem('savedDiscounts', 'true')
  if (location.pathname === '/cart') location.reload();
} else if (savedDiscounts && !onePlanetMembership.isSubscribed) {
  localStorage.removeItem('savedDiscounts')
}

customElements.define('password-input',
  class extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.toggle = this.querySelector('.password-input-icon')

      this.toggle.addEventListener('click', this.toggleInput.bind(this))
    }

    toggleInput() {
      this.input.type = this.input.type === 'password' ? 'text' : 'password'
    }
  }
);

const headerMemberships = document.querySelectorAll('.header-membership')
headerMemberships.forEach(headerMembership => {
  headerMembership.onclick = (e) => {
    if (!e.target.closest('.membership-block-info')) headerMembership.classList.toggle("active")
  }
})

const membershipATC = document.querySelector('body[data-membership="true"] .productInfo form .button#AddToCart')
if (membershipATC) membershipATC.onclick = () => {
  let canvas = document.createElement("canvas");
  canvas.width = 600;
  canvas.height = 600;
  let container = membershipATC.parentElement;
  container.appendChild(canvas);
  let confetti_button = confetti.create(canvas);
  confetti_button({
    particleCount: 200,
    spread: 200,
    startVelocity: 15,
    scalar: 0.9,
    ticks: 90
  }).then(() => container.removeChild(canvas));
}

const giftForm = document.querySelector('.subscription-form')
if (giftForm && giftForm.querySelectorAll('[data-add-gift]')) {
  const sellingPlan = giftForm.dataset.plan;
  const variant = giftForm.dataset.membership;
  const property = giftForm.dataset.property

  giftForm.querySelectorAll('[data-add-gift]').forEach((addGiftButton) => {
    const id = addGiftButton.dataset.id;
    const properties = {};
    properties[property] = true;

    addGiftButton.addEventListener('click', async function () {
      if (addGiftButton.classList.contains('disabled')) return;
      addGiftButton.classList.add('disabled')
      // Initiate checkout with discount
      await fetch('/checkout?discount=' + onePlanetMembership.firstDiscountCodes).catch(err => {
        console.error('Error adding discounts', err)
      });

      const formData = {
        items: [
          {
            id: Number(variant),
            quantity: 1,
            selling_plan: Number(sellingPlan),
          },
          {
            id: Number(id),
            properties
          },
        ]
      }
      try {
        document.body.classList.add('body-loading')
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        });

        if (!cartResponse.ok) {
          throw new Error('Failed to add items to the cart');
        }

        // Set discount code in a cookie
        document.cookie = `discount_code=${encodeURIComponent(onePlanetMembership.firstDiscountCodes)}; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT; secure`;

        // Submit form
        addGiftButton.closest('form').submit();
      } catch (error) {
        console.error('Error adding gift:', error);
        document.body.classList.remove('body-loading')
      } finally {
        // Re-enable the button if necessary
        addGiftButton.classList.remove('disabled');
      }
    })
  })
}

const orderDropdowns = document.querySelectorAll('.customerOrderDropdown')
if (orderDropdowns) orderDropdowns.forEach(orderDropdown => {
  orderDropdown.onclick = () => orderDropdown.classList.toggle('active')
})
